import React, { Component } from 'react';
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CircularProgress } from 'material-ui/Progress';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';


import TableCell from './tablecell';

import ContainerHeader from '../../../components/ContainerHeader/index';
import CardBox from '../../../components/CardBox/index';
import * as customerdetails from '../../../actions/customerdetails';

class CustomerList extends Component {

    componentDidMount() {
        // console.log('props', this.props)
        this.props.actions.fetchCustomerDetailsList();
    }

    render() {
        const { match, getDataList } = this.props;

        let dataList = <tr><td></td></tr>;
        let message = null;
        // console.log('getDataList', getDataList);
        if (getDataList && getDataList.Status) {
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        else if (getDataList && getDataList.customerdetailsList && getDataList.customerdetailsList.length > 0) {
            dataList = getDataList.customerdetailsList.map((_data, index) => {
                return (<TableCell key={index} data={_data} index={index} />);
            })
        }

        return (
            <div className="slideInUpTiny">
            {message}
                <ContainerHeader title="Customer List" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <Card className="shadow border-0">
                            <CardHeader className="bg-primary text-white">Customer List</CardHeader>
                            <CardBody>
                                <div className="col-12">
                                    <div className="table-responsive-material">
                                        <table className="default-table table-unbordered table table-lg table-hover">
                                            <thead className="th-border-b">
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Customer Name</th>
                                                    <th>Contact Name</th>
                                                    <th>Email Id</th>
                                                    <th>Contact No</th>
                                                    <th>Sub Date</th>
                                                    <th className="status-cell text-right">Actions</th>
                                                    <th />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dataList}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </div>
            </div >
        );
    }
}

function mapStateToProps(state, ownProps) {
    // console.log('state=>', state)
    const { getCustomerList } = state
    const { match } = ownProps
    return { match, getDataList: getCustomerList }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(customerdetails, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);



// WEBPACK FOOTER //
// ./app/customerdetails/customerlist/index.js